import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Link from '@mui/material/Link';
import lightBulbUrl from '@repo/assets/icons/lightbulb-large.svg?url';
import { colorPalette } from '@repo/mui-config/color-palette';

export const KrsLink = () => {
  const { t } = useTranslation();

  return (
    <Link href="https://wyszukiwarka-krs.ms.gov.pl/" target="_blank">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderRadius: '8px',
          backgroundColor: colorPalette.ice.dark,
          height: '56px',
          width: '100%',
          paddingLeft: '8px',
          paddingRight: '18px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <Box
            component="img"
            src={lightBulbUrl}
            alt="lightbulb"
            sx={{ width: '40px', opacity: 0.2 }}
          />
          <Box>
            <Typography fontSize={{ xs: 12, xl: 14 }} fontWeight="bold">
              {t(
                'welcomePage.loanApplicationPossible.liberis.beneficientData.partnershipForm.notSureOfParticipation',
              )}
            </Typography>
            <Typography fontSize={{ xs: 11, xl: 12 }}>
              {t(
                'welcomePage.loanApplicationPossible.liberis.beneficientData.partnershipForm.lookIntoTheKRS',
              )}
            </Typography>
          </Box>
        </Box>

        <OpenInNewIcon sx={{ color: colorPalette.primary.main }} />
      </Box>
    </Link>
  );
};
